<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { Helper } from '@/mixin/helper'
import VideoPlayer from '@/components/Video/VideoPlayer.vue'
import { mapGetters } from 'vuex'
/**
 * Starter component
 */
export default {
  name: 'ModalCall',
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'gmap-custom-marker': GmapCustomMarker,
    VideoPlayer,
  },
  mixins: [Helper],
  data() {
    return {
      showHideDetailNotif: false,
      phaseOneShow: false,
      detail: {},
      popoverShow: false,

      playerInOptions: {
        autoplay: true,
        controls: false,
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
        },
        sources: [
          {
            src: '',
            type: 'video/mp4',
          },
        ],

        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
      },
      refsName: `videoInPlayerNotif`,
      isPlay: true,
      isMuted: false,
      isFullScreen: false,
      videoTitle: '',
    }
  },
  computed: {
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
    }),
    getStatusUpload() {
      return this.getStatusVideo(this.detail)
    },
  },
  mounted() {
    if (!localStorage.getItem('dms-detail-data')) {
      this.$router.push({
        name: 'Driver Monitoring System',
      })
    }
    this.detail = JSON.parse(localStorage.getItem('dms-detail-data'))
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },

    openVideo() {
      this.videoTitle =
        this.$i18n.locale === 'id'
          ? this.detail.alert.descriptionIdn
          : this.detail.alert.descriptionEng
      this.playerInOptions.sources[0].src = this.detail.formattedAlertData
      this.$bvModal.show('modal-video')
      if (this.isWhitelabel()) {
        this.changeThumbnailVideo()
      }
    },

    onInPlayerReady() {
      this.$refs[this.refsName].player.play()
    },

    onInPlayerError(e) {
      console.log(e)
    },

    onInPlayerWaiting() {
      setTimeout(() => {
        this.$refs[this.refsName].player.pause()
      }, 20 * 1000)
    },

    onInPlayerLoadedData(e) {
      console.log(e)
    },

    playInVideo(isPlay) {
      this.isPlay = !this.isPlay
      if (!isPlay) {
        this.$refs[this.refsName].player.pause()
        return
      }

      this.$refs[this.refsName].player.play()
    },

    muteInVideo(isMuted) {
      this.isMuted = !this.isMuted
      this.$refs[this.refsName].player.muted(isMuted)
    },

    fullScreen() {
      this.isFullScreen = true
      var elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen() {
      this.isFullScreen = false
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.webkitExitFullscreen) {
        /* Safari */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        /* IE11 */
        document.msExitFullscreen()
      }
    },

    changeThumbnailVideo() {
      const thumbnailWhitelabel = require('@/assets/images/thumbnailvideo-whitelabel.jpg')
      const root = document.querySelector(':root')
      root.style.setProperty('--thumbnail-video', `url('${thumbnailWhitelabel}')`)
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-liveview__map mc-liveview__map--notification">
      <div class="mc-liveview-ico">
        <span>
          <span class="mc-liveview-legend">
            <i class="mc-fa icon-outline_info" id="legend"></i>

            <b-popover
              target="legend"
              triggers="click"
              :show.sync="popoverShow"
              placement="rightmiddle"
              container="my-container"
              ref="popover"
            >
              <template #title>
                {{ $t('global.object.remarks') }}
                <i
                  @click="onClose"
                  class="mc-popover-close mc-fa icon-outline_close"
                  aria-hidden="true"
                ></i>
              </template>

              <div class="mc-popover-content mc-popover-content--legend">
                <ul>
                  <li>
                    <p>{{ $t('global.object.fleetStatus') }}</p>
                    <div>
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-green.png`)
                          "
                          alt
                        /><span>{{ $t('global.filter.running') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-orange.png`)
                          "
                          alt
                        /><span>{{ $t('global.filter.idle') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-red.png`)
                          "
                          alt
                        /><span>{{ $t('global.filter.parking') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-grey.png`)
                          "
                          alt
                        /><span>{{ $t('global.filter.offline') }}</span></label
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </b-popover>
          </span>
        </span>
      </div>

      <GmapMap
        id="map"
        ref="MapAddress"
        :center="{
          lat: parseFloat(detail.latitude),
          lng: parseFloat(detail.longitude),
        }"
        :zoom="14"
        class="mc-map"
      >
        <gmap-custom-marker
          :offsetY="25"
          :marker="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
        >
          <img
            :src="
              require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-dark-grey.png`)
            "
            :style="`transform: rotate(${parseInt(90)}deg);`"
            alt="mceasy-lifeview-car-icon"
          />
        </gmap-custom-marker>
        <GmapInfoWindow
          :position="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
          :opened="true"
        >
          <div class="mc-modal-fleet mc-modal-fleet--notif">
            <div class="mc-modal-fleet__item">
              <!-- username  -->
              <h3 class="mc-modal-fleet__item-title">
                {{ detail.vehicle ? detail.vehicle.licensePlate : '' }} -
                {{ detail.driver ? detail.driver.fullname : $t('global.text.noDriver') }}
                <a @click="$router.go(-1)">
                  <i class="mc-fa icon-outline_close"></i>
                </a>
              </h3>
              <div>
                <div
                  class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif clearfix mb-3 mt-3"
                >
                  <h4 class="text-warning float-start">
                    {{
                      detail.alert
                        ? $i18n.locale === 'id'
                          ? detail.alert.descriptionIdn
                          : detail.alert.descriptionEng
                        : ''
                    }}
                  </h4>
                  <div class="d-flex float-end">
                    <b-button
                      v-if="
                        [51, 52, 53, 54, 55, 56, 49, 110, 111, 50].includes(
                          parseInt(detail.alertCode)
                        )
                      "
                      :title="$t('global.media')"
                      class="me-2"
                      variant="primary"
                      :disabled="getStatusUpload != 'uploaded'"
                      @click="openVideo()"
                    >
                      <i class="mc-fa icon-fill_video"></i>
                      {{ $t('global.media') }}
                    </b-button>
                    <b-button
                      v-b-modal.modal-call
                      :disabled="true"
                      :title="$t('notification.action.callDriver')"
                      variant="outline-primary"
                    >
                      <i class="mc-fa icon-outline_phone"></i>
                      {{ $t('notification.action.callDriver') }}
                    </b-button>
                  </div>
                </div>
                <dl class="mc-modal-fleet__item-list clearfix">
                  <dt v-if="getStatusUpload != 'uploaded'">
                    {{ $t('liveView.text.videoStatus') }}
                  </dt>
                  <dd v-if="getStatusUpload != 'uploaded'">
                    <span
                      v-if="getStatusUpload == 'pending'"
                      class="mc-status mc-status--blue mc-status-map"
                      >{{ $t('global.action.uploadProcess') }}</span
                    >
                    <span
                      v-if="getStatusUpload == 'failed'"
                      class="mc-status mc-status--red mc-status-map"
                      >{{ $t('global.action.notAvailable') }}</span
                    >
                  </dd>
                  <dt>{{ $t('global.time.time') }}</dt>
                  <dd>
                    {{ momentDateShortMonth(detail.createdOn) }} -
                    {{ momentTimeSeconds(detail.createdOn) }}
                  </dd>
                  <dt>{{ $t('liveView.infoWindow.location') }}</dt>
                  <dd>{{ detail.address }}</dd>
                  <dt v-if="detail.alertCode == '8' || detail.alertCode == '18'">
                    {{
                      detail.alertCode == '8'
                        ? $t('liveView.infoWindow.speed')
                        : $t('global.alert.temperature')
                    }}
                  </dt>
                  <dd v-if="detail.alertCode == '8' || detail.alertCode == '18'">
                    {{ detail.actual }}
                    {{ detail.alertCode == '8' ? 'Km/' + $t('global.time.hours') : '&#176; C' }}
                  </dd>
                  <dt v-if="detail.alertCode == '8'">{{ $t('global.object.limit') }}</dt>
                  <dd v-if="detail.alertCode == '8'">
                    {{ detail.limit }} Km/{{ $t('global.time.hours') }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="mc-modal-fleet__item" v-if="phaseOneShow">
              <b-form-group
                :label="$t('notification.text.comment')"
                label-for="text-comment"
                class="mb-3"
              >
                <b-form-textarea
                  :disabled="true"
                  id="text-comment"
                  size="lg"
                  :placeholder="$t('notification.text.writeComment')"
                />
              </b-form-group>
              <div class="mc-modal-fleet__item-status--notif-list">
                <div class="mc-modal-fleet__item-status--notif-list-item">
                  <h4>
                    Admin 1 <span>{{ $t('global.time.today') }}</span>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet ipsum dolor sit amet ipsum dolor sit amet ipsum dolor
                    sit amet ipsum dolor sit amet
                  </p>
                  <i class="mc-fa icon-outline_more-vertical"></i>
                </div>
                <div class="mc-modal-fleet__item-status--notif-list-item">
                  <h4>
                    Admin 1 <span>{{ $t('global.time.today') }}</span>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet ipsum dolor sit amet ipsum dolor sit amet ipsum dolor
                    sit amet ipsum dolor sit amet
                  </p>
                  <i class="mc-fa icon-outline_more-vertical"></i>
                </div>
              </div>
            </div>
            <h4
              class="mc-sidebar-liveview__list-notif-more d-block btn btn-outline-primary mt-3"
              :class="showHideDetailNotif ? 'mc-notif-close' : 'mc-notif-open'"
              v-on:click="showHideDetailNotif = !showHideDetailNotif"
              v-if="phaseOneShow"
            >
              <span class="mc-notif-open-text"
                ><i class="mc-fa icon-outline_arrow-ios-down"></i>
                {{ $t('global.action.seeMore') }}</span
              >
              <span class="mc-notif-close-text"
                ><i class="mc-fa icon-outline_arrow-ios-up"></i>
                {{ $t('global.action.close') }}</span
              >
            </h4>
          </div>
        </GmapInfoWindow>
      </GmapMap>
    </div>
    <b-modal
      class="mc-modal"
      id="modal-call"
      ref="modal-call"
      :title="$t('notification.action.callDriver')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.register')"
      :cancel-title="$t('global.action.close')"
      cancel-variant="outline-primary"
      size="md"
      centered
    >
      <b-row align-h="center">
        <b-col>
          <b-form-group
            id="fieldset-1"
            :label="$t('notification.text.enterNumber')"
            label-for="noHP"
          >
            <b-input-group prepend="+62">
              <b-form-input
                id="noHP"
                trim
                :placeholder="`${this.$t('global.action.enterNumber')}...`"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      id="modal-video"
      :title="`${this.$t('notification.object.notificationVideo')} - ${this.videoTitle}`"
      hide-footer
      size="xl"
      centered
      ref="modal-video"
      :modal-class="`mc-modal-video ${
        !isFullScreen ? 'mc-modal-video--liveview' : 'mc-modal-video--liveview-full'
      }`"
    >
      <div class="mc-modal-video__Wrapper">
        <div class="mc-modal-video__top">
          <b-row>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.licensePlate') }}</span>
                <div>
                  <strong>{{ detail.vehicle ? detail.vehicle.licensePlate : '-' }}</strong>
                  <b-badge class="bg-success" :title="$t('liveView.filter.moving')">{{
                    $t('liveView.filter.moving')
                  }}</b-badge>
                </div>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.fleetCategory') }}</span>
                <strong>{{
                  detail.vehicle
                    ? detail.vehicle.vehicleType
                      ? detail.vehicle.vehicleType.category
                      : '-'
                    : '-'
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.driver') }}</span>
                <strong>{{
                  detail.driver ? detail.driver.fullname : $t('global.text.noDriver')
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">{{ $t('global.object.phoneNumber') }} GPS</span>
                <strong>{{
                  detail.vehicle
                    ? detail.vehicle.device
                      ? detail.vehicle.device.phoneNo
                      : '-'
                    : '-'
                }}</strong>
              </div>
            </b-col>
            <b-col md="2">
              <div class="mc-modal-video__top-item">
                <span class="d-block text-muted">IMEI</span>
                <strong>{{ detail.vehicle ? detail.vehicle.imei : '-' }}</strong>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="mc-modal-video__content">
          <div
            class="mc-trackvideo-list__item-video-content-wrapper mc-trackvideo-list__item-video-content-open"
          >
            <div class="mc-trackvideo-list__item-video-content-open-source">
              <video-player
                ref="videoInPlayerNotif"
                class="vjs-custom-skin"
                :options="playerInOptions"
                @ready="onInPlayerReady($event)"
                @error="onInPlayerError($event)"
                @waiting="onInPlayerWaiting($event)"
                @loadeddata="onInPlayerLoadedData($event)"
              />
            </div>
            <div
              class="d-flex justify-content-between mc-trackvideo-list__item-video-content-action"
            >
              <div>
                <span>
                  <i
                    class="mc-fa icon-outline_play-circle"
                    v-if="!isPlay"
                    @click="playInVideo(true)"
                  ></i>
                  <i
                    class="mc-fa icon-outline_pause-circle"
                    v-if="isPlay"
                    @click="playInVideo(false)"
                  ></i>
                </span>
              </div>
              <div>
                <span>
                  <i
                    class="mc-fa icon-outline_volume-up"
                    v-if="!isMuted"
                    @click="muteInVideo(true)"
                  ></i>
                  <i
                    class="mc-fa icon-outline_volume-off"
                    v-if="isMuted"
                    @click="muteInVideo(false)"
                  ></i>
                </span>
                <i v-if="!isFullScreen" class="mc-fa icon-outline_expand" @click="fullScreen"></i>
                <i v-else class="mc-fa icon-outline_collapse" @click="closeFullscreen"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
